export const VAIX_IFRAME_ID = 'V3VaixRecommendationsWidget';
